import React from "react";
import { Skeleton } from "@mui/material";

const MappingSkeleton = ({ fields }) => {
  return (
    <div className="mapping__group mapping__group--skeleton">
      <div className="mapping__group__header">
        <Skeleton
          sx={{ backgroundColor: "#e8edf3" }}
          variant="text"
          animation={false}
          width={120}
          height={20}
        />
        <div className="mapping__group__header__actions">
          <div className="mapping__group__header__action mapping__group__header__action--skeleton"></div>
          <div className="mapping__group__header__action mapping__group__header__action--skeleton"></div>
        </div>
      </div>
      <div className="mapping__group__skeleton-cell"></div>
    </div>
  );
};

export default MappingSkeleton;
